import clsx from "clsx";
import { Col, ModalProps } from "@commonlibs";
import { createModal } from "@commonlibs";
import Modal from "ui/common/components/feedback/Modal/Modal";
import ModalFooter from "ui/common/components/feedback/Modal/ModalFooter/ModalFooter";
import useTranslate from "ui/locale/hooks/useTranslate";
import { Typography } from "@commonlibs";
import useDeleteGiftCardStock from "features/giftcards/hooks/useDeleteGiftCardStock";
import { GiftCardStockRow } from "common/models/api/models/GiftCardStock";

const DeleteGiftCardStockModal = createModal<{ giftCard: GiftCardStockRow } & ModalProps>(({ className, giftCard, close, ...rest }) => {
    const translate = useTranslate();

    const { mutate: deleteGiftCardStock, isLoading: isDeletingGiftCard } = useDeleteGiftCardStock({ onSuccess: close });

    function onDelete() {
        deleteGiftCardStock(giftCard.stockId);
    }

    return (
        <Modal
            title={translate("deleteGiftCard")}
            className={clsx("delete-gift-card-modal", className)}
            style={{ width: "550px" }}
            {...rest}
        >
            <Col style={{ marginBottom: "25px" }} gap={10}>
                <Typography variant="body2Regular" style={{ whiteSpace: "pre-line" }}>
                    {translate("deleteGiftCardModalMessage")}
                </Typography>
            </Col>
            <ModalFooter isLoading={isDeletingGiftCard} cancelLabel={translate("goOut") as string} mainLabel={translate("delete")} onCancel={close} onSubmit={onDelete} />
        </Modal>
    );
});

export default DeleteGiftCardStockModal;
